import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsProductsDvcsRoute: InvariantJiraRoute = {
	name: 'global-settings-products-dvcs',
	path: '/secure/admin/ConfigureDvcsOrganizations!default.jspa',
};
